import _ from 'lodash';
import { ANNOTATION_TYPE } from '../../../config';

type PatternInstance = {
  type: any;
  canvasChart: any;
  ctxChart: any;
  config: any;
  displayedChannelsArr: any;
  pixelSamples: any;
  channelIndex: any;
  startSample: any;
  endSample: any;
  color: any;
};

let Pattern;

(function () {
  Pattern = function (
    this: PatternInstance,
    canvasChart: any,
    config: any,
    displayedChannelsArr: any,
    pixelSamples: any,
    pattern: any,
  ) {
    this.type = ANNOTATION_TYPE.PATTERN;
    this.canvasChart = canvasChart;
    this.ctxChart = this.canvasChart.getContext('2d');
    this.config = config;
    this.displayedChannelsArr = displayedChannelsArr;
    this.pixelSamples = pixelSamples;
    this.channelIndex = pattern.channelIndex;
    this.startSample = pattern.startSample;
    this.endSample = pattern.endSample;
    this.color = 'blue';
  };

  Pattern.prototype.drawOnePattern = function (
    this: PatternInstance,
    offsetX: any,
    strokeStyle = this.color,
  ) {
    this.ctxChart.beginPath();
    this.ctxChart.strokeStyle = strokeStyle;
    _.forEach(this.displayedChannelsArr, (element, index) => {
      if (this.channelIndex === element) {
        for (let j = this.startSample; j < this.endSample; j += 1) {
          this.ctxChart.moveTo(
            this.pixelSamples[index][j].x - this.pixelSamples[index][offsetX].x,
            this.pixelSamples[index][j].y,
          );
          this.ctxChart.lineTo(
            this.pixelSamples[index][j + 1].x - this.pixelSamples[index][offsetX].x,
            this.pixelSamples[index][j + 1].y,
          );
        }
      }
      this.ctxChart.stroke();
      this.ctxChart.closePath();
    });
  };

  Pattern.prototype.update = function (
    this: PatternInstance,
    pixelSamples: any,
    config: any,
    displayedChannelsArr: any,
  ) {
    this.pixelSamples = pixelSamples;
    this.config = config;
    this.displayedChannelsArr = displayedChannelsArr;
  };

  Pattern.prototype.changeColor = function (this: PatternInstance, color: any) {
    this.color = color;
  };

  Pattern.prototype.getJSONObject = function (this: PatternInstance) {
    return {
      type: this.type,
      channelIndex: this.channelIndex,
      startSample: this.startSample,
      endSample: this.endSample,
      color: this.color,
    };
  };
})();

export { Pattern };
export default { Pattern };
